document.addEventListener('DOMContentLoaded', () => {
    const original = document.getElementById('MBSelectOriginal');
    const sentinel = document.getElementById('MBSelectSentinel');
    const mount = document.getElementById('MBSelectStickyMount');

    if (!original || !sentinel || !mount) return;

    const HEADER_HEIGHT = 80;
    let clone = null;
    let observer = null;

    const enableSticky = () => {
        if (observer) return;

        observer = new IntersectionObserver(
            ([entry]) => {
                const passedTop = entry.boundingClientRect.top < HEADER_HEIGHT;

                if (!entry.isIntersecting && passedTop && !clone) {
                    clone = original.cloneNode(true);
                    clone.classList.add('MBSelect--sticky');
                    clone.classList.remove('d-xl-none');
                    clone.classList.add('d-block');
                    clone.removeAttribute('id');
                    mount.appendChild(clone);
                }

                if (entry.isIntersecting && clone) {
                    clone.remove();
                    clone = null;
                }
            },
            {
                rootMargin: `-${HEADER_HEIGHT}px 0px 0px 0px`,
                threshold: 0
            }
        );

        observer.observe(sentinel);
    };

    const disableSticky = () => {
        if (observer) {
            observer.disconnect();
            observer = null;
        }

        if (clone) {
            clone.remove();
            clone = null;
        }
    };

    const mediaQuery = window.matchMedia('(max-width: 1199px)');

    const handleBreakpoint = (e) => {
        if (e.matches) {
            enableSticky();   // mobile
        } else {
            disableSticky();  // desktop
        }
    };

    // Initial run
    handleBreakpoint(mediaQuery);

    // React to resize
    mediaQuery.addEventListener('change', handleBreakpoint);
});